/* eslint-disable jira/filename-case */
import type { ResolverOverride } from '@jira/platform__utils-feature-flagging';

const visualRefreshPlatformFlags = ['platform-component-visual-refresh'];

export const visualRefreshResolverOverride: ResolverOverride = [
	(flagKey: string) => visualRefreshPlatformFlags.includes(flagKey),
	() => true,
];
